// Core
import styled from 'styled-components';

// Plugins
import { BREAKPOINTS } from '../../config/screen';

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
`;

export const SuperiorNumberRowContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EquipmentImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  };
`;

export const InstalledAtContainer = styled.span`
  min-width: 100px;
`;

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableContainer = styled.div`
  padding: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.5rem 2.75rem 2.5rem 2.75rem;
  };
`;

export const CardsContainer = styled.div`
  padding: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.5rem 2.75rem 2.5rem 2.75rem;
  };
`;
